import { render, staticRenderFns } from "./contactUs.vue?vue&type=template&id=095f79cc&scoped=true&"
import script from "./contactUs.vue?vue&type=script&lang=ts&"
export * from "./contactUs.vue?vue&type=script&lang=ts&"
import style0 from "./contactUs.vue?vue&type=style&index=0&id=095f79cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095f79cc",
  null
  
)

export default component.exports